export default "__VITE_ASSET__bKA1pumf__"